import { useAppData } from "#app/lib/data";

// Permissions 2.0: User.permissions is a flat { key: true } map of granted
// registry keys (e.g. "manage.users", "create.workflows"). A direct key
// lookup matches how the server seeds and resolves cells.
//
// `permKey` is a single dot-notation key from the registry. Logical
// expressions (`|`, `&`) and context-args (issue/team objects) are not
// modeled here — call sites pass plain keys. If we need expression
// support, layer it on top.
export function usePermission(permKey: string): boolean {
  const { currentUser } = useAppData();
  const permissions = currentUser?.permissions;
  if (!permissions || !permKey) return false;
  return permissions[permKey] === true;
}

// Imperative variant. Useful in event handlers / callbacks where you
// already have the perms map in scope.
export function checkPermission(
  permissions: Record<string, unknown> | null | undefined,
  permKey: string,
): boolean {
  if (!permissions || !permKey) return false;
  return permissions[permKey] === true;
}
